<script lang="ts">
  import { Fieldset, Properties } from '@factry/components'
  import { lengthUOM } from '../utils/datasets'
  import type { AssetEvent } from '../types'

  export let event: AssetEvent | undefined
  export let length: number
  export let thickness: number

  let leftProperties: Record<string, unknown> = {}
  let rightProperties: Record<string, unknown> = {}

  function splitProperties (event: AssetEvent | undefined): void {
    if (!event) return

    leftProperties = {
      Recipe: event.recipe,
      Length: `${length} ${lengthUOM}`,
      'Wall Thickness': `${thickness} ${event?.wall_thickness_uom || ''}`,
    }
    const excludedKeys = ['recipe']
    rightProperties = Object.fromEntries(
      Object.entries(event).filter(([key]) =>
        !key.includes('_periodic') &&
        !excludedKeys.includes(key))
    )
  }

  $: splitProperties(event)
</script>

<style lang="scss">
  @import '../utils/base';

  .columns {
    justify-content: center;
  }

  .column.is-6 {
    @media (min-width: 1000px) {
      max-width: 700px;
    }

    :global(.fieldset) {
      background-color: $white;
      border-radius: $radius;
      border: 1px solid $border;
      padding: $spacing !important;

      :global(legend) {
        text-shadow: 2px 2px 2px white,
          -2px 2px 2px white,
          2px -2px 2px white,
          -2px -2px 2px white !important;
      }

      :global(.property-field:not(:last-child)) {
        border-bottom: 1px solid $grey-lightest;
        margin-bottom: $spacing * 0.25;
        padding-bottom: $spacing * 0.25;
      }

      @include from($tablet) {
        :global(.field-label) {
          flex: unset;
          text-align: left;

          :global(.label) {
            font-weight: normal;
          }
        }
      }
      @include from($tablet) {
        :global(.field-body) {
          flex: unset;
          margin-left: auto;
          text-align: right;
        }
      }
    }
  }
</style>

<div class="columns">
  <div class="column is-6">
    <Fieldset label="Technical specification" hasFloatingLegend>
      <Properties
        horizontal
        edit={false}
        properties={leftProperties}
        allowNew={false}
      />
    </Fieldset>
  </div>

  <div class="column is-6">
    <Fieldset label="Production data" hasFloatingLegend>
      <Properties
        horizontal
        edit={false}
        properties={rightProperties}
        allowNew={false}
      />
    </Fieldset>
  </div>
</div>
